import { Marker } from "react-map-gl/mapbox";
import "./MapVehicle.css";

export function MapVehicle({ data, onSelect }) {
  const coordinates = data?.location?.coordinates;

  if (
    !Array.isArray(coordinates) ||
    coordinates.length !== 2 ||
    typeof coordinates[0] !== "number" ||
    typeof coordinates[1] !== "number"
  ) {
    return null;
  }

  const [lng, lat] = coordinates;

  function getStatusColor(status) {
    switch (status) {
      case "completed":
        return "#12B76A";
      case "ongoing":
        return "#2970FF";
      case "at-final-stop":
        return "#FBBF24";
      default:
        return "#6B7280";
    }
  }

  return (
    <Marker latitude={lat} longitude={lng} onClick={() => onSelect(data)}>
      <div className="marker-wrapper">
        <div
          className="marker-container"
          style={{ "--marker-color": getStatusColor(data.status) }}
        >
          <div className="ring ring-lg" />
          <div className="ring ring-md" />
          <div className="ring ring-sm" />
        </div>
        {(data?.vehicleDetails?.busNumber || data?.tripName) && (
          <div className="marker-label">
            {data?.vehicleDetails?.busNumber && data?.tripName
              ? `${data.vehicleDetails.busNumber} - ${data.tripName}`
              : data?.vehicleDetails?.busNumber || data?.tripName || "Unknown"
            }
          </div>
        )}
      </div>
    </Marker>
  );
}
